import type { LicenseUsage } from '~/types/settings'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const useFetchLicense = () => {
  const url = '/me/licenses'

  const { get } = useFetchWithDefaults()

  const getAll = ({ workspaceId }: WorkspaceIdentifier) =>
    get<{ data: LicenseUsage }>({ url, workspaceId })

  return {
    getAll,
  }
}
